module.exports = __webpack_public_path__ + "img/netflix-bg.268d2fcb.svg";